/**
 * Created by matheusmorett on 14/12/17.
 */
// IPv4 privado (10/8, 172.16/12, 192.168/16), loopback ou hostname sem domínio (ex.: nome da VM)
export function isPrivateHost(hostname) {
  if (!hostname) return false;
  if (/^(10\.|127\.|192\.168\.|172\.(1[6-9]|2[0-9]|3[01])\.)\d+\.\d+$/.test(hostname)) return true;
  return !hostname.includes('.');
}

export function _env() {
  const location = window.location.href;
  if (location.includes('hero99')) {
    return 'homolog';
  }

  if (location.includes('dev')) {
    return 'local';
  }

  if (location.includes('localhost')) {
    return 'local';
  }

  // Acesso ao dev-server pelo IP da VM / rede privada (ex.: http://192.168.86.234:3010)
  if (isPrivateHost(window.location.hostname)) {
    return 'local';
  }

  if (location.includes('adrenalyze.com.br') || location.includes('adrena.me')) {
    return 'prod';
  }
  return process.env.NODE_ENV;
}

const apiUrl = () => {
  if (_env() === 'prod') {
    return 'https://api.adrenalyze.com.br/';
  } else if (_env() === 'homolog') {
    return 'https://api.hero99.adrenalyze.com.br/';
  } else if (_env() === 'local') {
    // API local no mesmo host de onde o site foi aberto (localhost ou IP da VM).
    // Porta configurável em build/dev via REACT_APP_API_PORT (default 8090 = adrenalyze-back principal).
    const port = process.env.REACT_APP_API_PORT || '8090';
    return `http://${window.location.hostname}:${port}/api/web/`;
    // return 'http://0.0.0.0:8090/api/web/v1/';
    // return 'http://dev.back.adrenalyze.com.br/';
    // return 'https://api.hero99.adrenalyze.com.br/';
  }
  return 'https://letsrock.hero99.com.br/clientes/adrenalyze-back/api/web/';
};

export const API_URI = apiUrl();
